var Button = require('treeline-shared-components/button');
var FeaturePopupDefaultView = Marionette.LayoutView.extend({
  template: require('./feature-popup-content-default-view.tpl'),
  className: 'container-fluid',
  regions: {
    moreInfoBtnRegion: '.feature-popup-content-more-info-btn'
  },
  initialize: function (options) {
    this.options = _.defaults(
        options || {},
        {
            title: 'Point title',
            description: 'Lorem ipsum, blah blah blah',
            featureImageUrl: undefined,
            moreInfoUrl: undefined,
            type: 'default', // maybe, will make this video, sound, etc. Or pass in a view not sure.
            childView: undefined
        }
    );
    this.model = this.options.model || new Backbone.Model();
  },
  serializeData: function () {
    return {
      title: this.options.title,
      description: this.options.description,
      featureImageUrl: this.options.featureImageUrl,
      moreInfoUrl: this.options.moreInfoUrl
    };
  },
  onRender:function () {
    var self = this;
    if (this.options.moreInfoUrl) {
      this._moreInfoBtn = new Button.Button({
          label: 'More Info',
          classNames: 'tl-more-info-btn',
          enabled: true,
          theme: Button.THEMES.DEFAULT,
          size: Button.SIZES.SMALL,
          onClickedCallback: function () {
              window.open(self.options.moreInfoUrl, '_blank');
          }
      });
      this.moreInfoBtnRegion.show(this._moreInfoBtn);
    }
  }
});

module.exports = FeaturePopupDefaultView;



/** WEBPACK FOOTER **
 ** ./assets/js/common/locations-map/feature-popup-content/feature-popup-content-default-view.js
 **/